import React from "react";

const RISK = {
  low: { color: "var(--success)", bg: "var(--success-soft)", label: "Low" },
  medium: { color: "var(--warn)", bg: "var(--warn-soft)", label: "Medium" },
  high: { color: "var(--danger)", bg: "var(--danger-soft)", label: "High" },
  critical: { color: "#FFFFFF", bg: "var(--danger)", label: "Critical" },
};

const STATUS_MAP = {
  positive: ["approved", "done", "active", "granted", "sent", "verified", "responded", "implemented", "closed", "confirmed"],
  warn: ["review", "partial", "pending", "in_progress", "investigating", "contained", "withdrawn", "under_review", "notified"],
  danger: ["not_implemented", "refused", "critical", "rejected", "failed", "expired"],
};

function classifyStatus(key) {
  if (STATUS_MAP.positive.includes(key)) return { color: "var(--success)", bg: "var(--success-soft)" };
  if (STATUS_MAP.warn.includes(key)) return { color: "var(--warn)", bg: "var(--warn-soft)" };
  if (STATUS_MAP.danger.includes(key)) return { color: "var(--danger)", bg: "var(--danger-soft)" };
  return { color: "var(--muted)", bg: "var(--bg-2)" };
}

export function RiskBadge({ level, className = "" }) {
  const key = String(level || "medium").toLowerCase();
  const tone = RISK[key] || RISK.medium;
  return (
    <span
      data-testid={`risk-badge-${key}`}
      className={`inline-flex items-center gap-1 px-2 py-[3px] text-[10.5px] font-semibold rounded-md ${className}`}
      style={{ color: tone.color, background: tone.bg, letterSpacing: "0.01em" }}
    >
      <span className="w-1.5 h-1.5 rounded-full" style={{ background: tone.color }} />
      {tone.label}
    </span>
  );
}

export function StatusBadge({ status, className = "" }) {
  const key = String(status || "open").toLowerCase();
  const tone = classifyStatus(key);
  const label = key.replace(/_/g, " ");
  return (
    <span
      data-testid={`status-badge-${key}`}
      className={`inline-flex items-center gap-1.5 px-2 py-[3px] text-[10.5px] font-medium rounded-md capitalize ${className}`}
      style={{ color: tone.color, background: tone.bg }}
    >
      <span className="w-1.5 h-1.5 rounded-full" style={{ background: tone.color }} />
      {label}
    </span>
  );
}
